import { operatorClientWithLang } from 'domain/HttpClients';
import moment from 'moment';

export const scanWaybillDocs = async (tripId, itineraryId) => {
  const response = await operatorClientWithLang
    .Get('/api/itineraries/scan-waybill-doc')
    .withParams({
      tripId,
      itineraryId,
    })
    .send();
  return response;
};

export const triggerEvent = async (events, id, locationId, stopItems, lateReason, locationType) => {
  const response = await operatorClientWithLang
    .Post('/api/itineraries/trigger-event')
    .withData({
      itineraryEventType: events,
      itineraryId: id,
      locationId,
      locationType,
      lateReason,
      stopItems: stopItems && stopItems.length ? stopItems : null,
      timestamp: moment().toISOString(),
    })
    .send();
  return response;
};
